import { render, staticRenderFns } from "./edit-bulk-message-filters.vue?vue&type=template&id=7d4dfbe9&scoped=true&"
import script from "./edit-bulk-message-filters.vue?vue&type=script&lang=js&"
export * from "./edit-bulk-message-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4dfbe9",
  null
  
)

export default component.exports